import { useState } from "react";
import Head from "next/head";
import useUser from "../lib/useUser";
import { Layout } from "../common/Layout";
import { Imgix, Hero, Section } from "../common/UI";
import withSession from "../lib/session";
import {
  Container,
  Grid,
  Button,
  Box,
  Typography,
  Divider,
} from "@mui/material";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
// import styles from 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from "react-responsive-carousel";

export default function LocationsPage() {
  return (
    <Layout>
      <Grid item style={{ maxWidth: "100vw" }}>
        <Hero
          minHeight={400}
          bgImg="https://bigsurf1.imgix.net/gold_coast.jpg?w=1200"
        >
          <Box sx={{}}>
            <Typography
              variant="h2"
              sx={{
                color: "white",
                textShadow: "0 1px 0 black",
                textAlign: "center",
              }}
            >
              Locations
            </Typography>
          </Box>
          <Box sx={{}}>
            <Typography
              variant="h4"
              sx={{
                color: "white",
                textShadow: "0 1px 0 black",
                textAlign: "center",
              }}
            >
              See the beaches where we surf, and meetup spots for lessons
            </Typography>
          </Box>
        </Hero>

        <Section id="menu">
          <Container>
            <Grid container>
              <Grid item md={6}>
                <Box sx={{ padding: "24px 0" }}>
                  <ul>
                    <li>
                      <a href="#carmel">
                        <span>
                          <i aria-hidden="true"></i>
                        </span>
                        Carmel Beach
                      </a>
                    </li>

                    <li>
                      <a href="#asilomar">
                        <span>
                          <i
                            // class="fas fa-umbrella-beach"
                            aria-hidden="true"
                          ></i>
                        </span>
                        Asilomar
                      </a>
                    </li>

                    <li>
                      <a href="#lovers">
                        <span>
                          <i
                            // class="fas fa-umbrella-beach"
                            aria-hidden="true"
                          ></i>
                        </span>
                        Lover's Point
                      </a>
                    </li>

                    <li>
                      <a href="#monterey">
                        <span>
                          <i
                            // class="fas fa-umbrella-beach"
                            aria-hidden="true"
                          ></i>
                        </span>
                        Del Monte Beach
                      </a>
                    </li>

                    <li>
                      <a href="#fishermans">
                        <span>
                          <i
                            // class="fas fa-umbrella-beach"
                            aria-hidden="true"
                          ></i>
                        </span>
                        Old Fisherman's Wharf
                      </a>
                    </li>
                  </ul>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Section>

        <Divider />
        <br />

        <Section id="carmel">
          <Container>
            <Grid container spacing={3}>
              <Grid item md={6}>
                <Typography variant="h4">Carmel Beach</Typography>
                <Typography variant="h5">
                  South end of Carmel Beach (consistent, rideable small waves
                  for beginners)
                </Typography>

                <p>
                  Meet{" "}
                  <strong>off of Martin Ave, next to the Sandpiper Inn</strong>.
                  <br />
                  <a
                    href="https://www.google.com/maps/place/Carmel+Beach/@36.5529601,-121.9403565,15z/data=!4m13!1m7!3m6!1s0x808de638ca0ad14f:0xbc66c137c614f4b5!2sCarmel+Beach!3b1!8m2!3d36.5521696!4d-121.9298893!3m4!1s0x808de640cb8239ff:0xb70ecfd8ea7bcdef!8m2!3d36.5549603!4d-121.9304994"
                    target="_blank"
                  >
                    View on Map
                  </a>
                </p>
                <p>
                  At the foot of Ocean Avenue, Carmel Beach is one of the most
                  iconic spots on California's Central Coast and is rated "One
                  of America's Top Beach Towns." From morning to night Carmel
                  Beach attracts visitors and locals alike to take in the
                  majestic scenery and fun activities. For surfers, the view
                  from the water is stunning; Point Lobos to the South and
                  Pebble Beach to the north with crystal clear water which adds
                  to the ambiance of an incredible ride. The beach to surf is
                  significantly affected by tide, wave duration, sand bar
                  formation and swell direction. The wave and water conditions
                  can change rapidly so trust our instructors and our safety
                  first intuition. Carmel Beach is surfed by locals and visitors
                  alike, but please remember proper surf etiquette (if you don’t
                  know what surfer etiquette is, please ask!), don't jump the
                  line, instead hang on the outside until the feel and mood has
                  been established then jump in, the water's fine — (cold) but
                  fine. A wetsuit is a must if you plan to remain in the water
                  for any length of time as the water hovers at a cool 50
                  degrees. Lucky for you Big Surf provides our student with the
                  best suits money can buy. Lessons can be held along the entire
                  length of the beach and your instructor will inform you where
                  to meet before the lesson.
                </p>
              </Grid>
              <Grid item md={6} zeroMinWidth>
                <Carousel
                  showArrows
                  showThumbs
                  dynamicHeight
                  //   autoPlay
                  stopOnHover
                  swipeable
                  infiniteLoop
                >
                  <div>
                    <img src="https://bigsurf1.imgix.net/carmel1.jpg?w=1200" />
                    <p className="legend">Carmel Beach 1</p>
                  </div>
                  <div>
                    <img src="https://bigsurf1.imgix.net/carmel2.jpg?w=1200" />
                    <p className="legend">Carmel Beach 2</p>
                  </div>
                  <div>
                    <img
                      src="https://bigsurf1.imgix.net/carmel-on-map.png?w=1200"
                      //   style="max-height:500px;"
                      //   style={{ width: 100 }}
                    />
                    <p className="legend">Map</p>
                  </div>
                </Carousel>

                <br />
              </Grid>
            </Grid>
          </Container>
        </Section>

        <Divider />
        <br />

        <Section id="asilomar">
          <Container>
            <Grid container spacing={3}>
              <Grid item md={6}>
                <Typography variant="h4">Asilomar Beach</Typography>
                <Typography variant="h5">Consistent waves</Typography>

                <p>
                  Meet at the{" "}
                  <strong>Asilomar Conference Grounds "Crosswalk"</strong> near{" "}
                  <strong>1870 Sunset Dr.</strong> in Pacific Grove.
                  <br />
                  <a
                    href="https://www.google.com/maps/place/Asilomar+State+Beach/@36.6180088,-121.9441002,17z/data=!3m1!4b1!4m5!3m4!1s0x808de125fdd7c0f5:0xbd02e27eb1cc42b8!8m2!3d36.6180088!4d-121.9419115"
                    target="_blank"
                  >
                    View on Map
                  </a>
                </p>
                <p>
                  There are few surfing spots around Monterey as popular as
                  Asilomar Beach. The consistent waves and wind bring surfers
                  here on a daily basis. But surfers aren’t the only ones in the
                  water: with plenty of wildlife in the area, you’re bound to
                  also see kayakers dot the water, looking to get an up-close
                  look at a wide range of marine creatures. Connected to Spanish
                  Bay (to the south) there are 5, yes count 'em, FIVE, different
                  places to catch different variations of waves at this
                  picturesque location. Roadside, Middles, Reefs, Spanish Bay
                  North Side, and Spanish Bay South Side. Be forewarned: the
                  conditions can change rapidly so this beach must be respected;
                  our instructors know when it’s safe to go out and when it’s
                  not.
                </p>

                <br />
              </Grid>
              <Grid item md={6} zeroMinWidth>
                <Carousel
                  showArrows
                  showThumbs
                  dynamicHeight
                  //   autoPlay
                  stopOnHover
                  swipeable
                  infiniteLoop
                >
                  <div>
                    <img src="https://bigsurf1public.imgix.net/public/1d2b89d9-9611-4325-b245-9cfa9a960d6d.jpg" />
                    <p className="legend">Asilomar Beach 1</p>
                  </div>
                  <div>
                    <img src="https://bigsurf1public.imgix.net/public/c7d7d07b-d2da-49b3-9924-97e24caa9508.jpg" />
                    <p className="legend">Asilomar Beach 2</p>
                  </div>
                  <div>
                    <img
                      src="https://bigsurf1.imgix.net/asilomar-on-map.png?w=1200"
                      //   style="max-height:500px;"
                      //   style={{ width: 100 }}
                    />
                    <p className="legend">Map</p>
                  </div>
                </Carousel>
              </Grid>
            </Grid>
          </Container>
        </Section>

        <Divider />
        <br />

        <Section id="lovers">
          <Container>
            <Grid container spacing={3}>
              <Grid item md={6}>
                <Typography variant="h4">Lover's Point</Typography>
                <Typography variant="h5">Experienced surfers' dream</Typography>

                <p>
                  Meet at the <strong>Lover's Point parking lot</strong>
                  <br />
                  <a
                    href="https://www.google.com/maps/place/Lover's+Point+Beach/@36.6251326,-121.9188875,17z/data=!3m1!4b1!4m5!3m4!1s0x808de14f7a68409b:0xa2f66d3cfb868577!8m2!3d36.6251326!4d-121.9166988"
                    target="_blank"
                  >
                    View on Map
                  </a>
                </p>
                <p>
                  To the experienced Surfer, Lover’s point is a dream wave. The
                  perfect left never closes out and can sometimes barrel,
                  provided the conditions are immaculate. With waves as inviting
                  as its name, it’s no wonder Lover's Point has become a
                  favorite spot for surfers. And with scenic wildlife, picnic
                  space, and a volleyball court, it’s also perfect for those who
                  want to do more than just surf. It’s even the starting point
                  of the “Kelp Crawl” portion of the Triathlon at Pacific Grove!
                  We don’t hold lessons here unless students have experience and
                  confidence in the waves. Be forewarned: it’s best you go out
                  with someone who knows this spot because there are rocks.
                </p>

                <br />
              </Grid>
              <Grid item md={6} zeroMinWidth>
                <Carousel
                  showArrows
                  showThumbs
                  dynamicHeight
                  //   autoPlay
                  stopOnHover
                  swipeable
                  infiniteLoop
                >
                  <div>
                    <img src="https://bigsurf1.imgix.net/loverspoint1.jpg?w=1200" />
                    <p className="legend">Lover's Point 1</p>
                  </div>
                  <div>
                    <img src="https://bigsurf1.imgix.net/loverspoint2.jpg?w=1200" />
                    <p className="legend">Lover's Point 2</p>
                  </div>
                  <div>
                    <img src="https://bigsurf1.imgix.net/loverspoint3.jpg?w=1200" />
                    <p className="legend">Lover's Point 3</p>
                  </div>
                  <div>
                    <img src="https://bigsurf1.imgix.net/loverspoint-on-map.png?w=1200" />
                    <p className="legend">Map</p>
                  </div>
                </Carousel>
              </Grid>
            </Grid>
          </Container>
        </Section>

        <Divider />
        <br />

        <Section id="monterey">
          <Container>
            <Grid container spacing={3}>
              <Grid item md={6}>
                <Typography variant="h4">Del Monte Beach</Typography>
                <Typography variant="h5">
                  Great for new surfers, and for relaxing afterwards!
                </Typography>

                <p>
                  Meet{" "}
                  <strong>in front of Surfside Apartments (1 Surf Way)</strong>.
                  <br />
                  <a
                    href="https://www.google.com/maps/place/Del+Monte+Beach/@36.5980679,-121.8705702,14.88z/data=!4m5!3m4!1s0x808de4449132bedb:0xbd2cc072e8f490b!8m2!3d36.6048572!4d-121.8690419"
                    target="_blank"
                  >
                    View on Map
                  </a>
                </p>
                <p>
                  The winds at Del Monte Beach are famous, so of course it’s a
                  favorite spot for surfers. Because of its weaker riptides,
                  patrolling lifeguards, and convenient beach access, it's a
                  surf spot best suited new surfers. And don’t be surprised if
                  you look out a little beyond the surf and see dolphins playing
                  in the waves! Bring you beach towels and sunscreen because
                  it’s also a great place to hangout before or after the lesson.
                </p>

                <br />
              </Grid>
              <Grid item md={6} zeroMinWidth>
                <Carousel
                  showArrows
                  showThumbs
                  dynamicHeight
                  //   autoPlay
                  stopOnHover
                  swipeable
                  infiniteLoop
                >
                  <div>
                    <img src="https://bigsurf1public.imgix.net/public/733926c8-542b-44ca-ac78-fda6b334b2ce.jpg?w=1200" />
                    <p className="legend">Del Monte Beach 1</p>
                  </div>
                  <div>
                    <img src="https://bigsurf1.imgix.net/monterey-on-map.png?w=1200" />
                    <p className="legend">Map</p>
                  </div>
                </Carousel>
              </Grid>
            </Grid>
          </Container>
        </Section>

        <Divider />
        <br />

        <Section id="fishermans">
          <Container>
            <Grid container spacing={3}>
              <Grid item md={6}>
                <Typography variant="h4">Old Fisherman's Wharf</Typography>
                <Typography variant="h5">Big Waves, Big Pictures</Typography>

                <p>
                  Meet{" "}
                  <strong>
                    along the wharf, in front of the London Bridge Pub.
                  </strong>
                  <br />
                  <a
                    href="https://www.google.com/maps/place/Old+Fisherman's+Wharf/@36.6034066,-121.8947162,16.64z/data=!4m5!3m4!1s0x808de41880edf8cd:0xdc0b163254a641c7!8m2!3d36.6039005!4d-121.8931123"
                    target="_blank"
                  >
                    View on Map
                  </a>
                </p>
                <p>
                  Situated adjacent to old fisherman’s wharf, this surf spot is
                  perfect for big wave days as it is very protected from
                  dangerous conditions. When it’s 10 foot in the Monterey area,
                  old fisherman’s wharf provides sheltered 2-4 foot surf. This
                  location really works when the tide is high, almost
                  disappearing at low tide. One of the best spots to take
                  pictures of surfers thanks to the wharf's elevated vantage
                  point.
                </p>

                <br />
              </Grid>
              <Grid item md={6} zeroMinWidth>
                <Carousel
                  showArrows
                  showThumbs
                  dynamicHeight
                  //   autoPlay
                  stopOnHover
                  swipeable
                  infiniteLoop
                >
                  <div>
                    <img src="https://bigsurf1public.imgix.net/public/a9f660fb-bfd3-42c6-8956-e13f92541178.jpg?w=1200" />
                    <p className="legend"> Old Fisherman's Wharf 1</p>
                  </div>
                  <div>
                    <img src="https://bigsurf1public.imgix.net/public/28ed321c-8395-413d-bf42-6641822996e5.jpg?w=1200" />
                    <p className="legend"> Old Fisherman's Wharf 2</p>
                  </div>
                  <div>
                    <img src="https://bigsurf1.imgix.net/fishermans-on-map.png?w=1200" />
                    <p className="legend">Map</p>
                  </div>
                </Carousel>
              </Grid>
            </Grid>
          </Container>
        </Section>

        <Hero minHeight={400} bg="#35baf6">
          <Typography
            variant="h2"
            sx={{
              color: "white",
              textShadow: "0 1px 0 black",
              textAlign: "center",
            }}
          >
            Whether it's your first time or you're eager to improve your skills,
            <br />
            Big Sur Surf Lessons will accommodate your learning needs!
          </Typography>
        </Hero>
      </Grid>
    </Layout>
  );
}

// export const getServerSideProps = withSession(async function ({ req, res }) {
//   const user = req.session.get("user") ?? null;
//   return {
//     props: { user },
//   };
// });
